import { z } from 'zod'

export const WORK_TASK_TRACKER_SPRINT_CONTRACT_VERSION = '1.0.0' as const
export const workTaskTrackerSprintResponseSchema = z.unknown()
export type WorkTaskTrackerSprintResponse = z.infer<typeof workTaskTrackerSprintResponseSchema>
